import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import css from './index.module.scss';
import EFXGuard from 'elem/ui-assets/icons/unregular/EFXGuard';
import EcoSpace from 'eco-design/base/eco-space';

const H: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidpro');

    return (
        <div id="rapid-pro-H" className={`rapid-pro-H ${css.section}`}>
            <EcoSpace />
            <div className="media">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1749009644408/9.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1749009644408/9.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1749009644231/9_M.jpg"
                />
            </div>
            <div className="info sec">
                <div className="info-logo">
                    <EFXGuard />
                </div>
                <p className="info-title">{t('H_title')}</p>
                <p className="info-desc">{t('H_desc')}</p>
                <div className="info-param">
                    <span className="info-param-num">{t('H_num')}</span>
                    <div className="info-param-suffix">
                        <p className="info-param-suffix-unit">{t('H_unit')}</p>
                        <p className="info-param-suffix-time">{t('H_time')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default H;
